export const CloudinaryWidgetScriptUrl =
  'https://upload-widget.cloudinary.com/latest/global/all.js'
